import React from "react";
import { useSelector } from "react-redux";
import { Spin } from "antd";
import { ToastContainer } from "react-toastify";

const LoadingScreen = () => {
	const isLoading = useSelector((state: any) => state.loading.isLoading);

	return (
		<>
			{isLoading && (
				<div className="fixed top-0 left-0 w-screen h-screen flex justify-center items-center bg-black bg-opacity-10 z-50">
					<Spin spinning={isLoading} size="large" />
				</div>
			)}
		</>
	);
};

export default LoadingScreen;
